import { ENTERPRISE_APPOINTMENT_STATUS } from '@avanta/shared/constants/appointments';
import { type EnterpriseAppointmentStatus } from '@avanta/shared/types/appointments';

export { ENTERPRISE_APPOINTMENT_STATUS };

/** Values accepted by the backend `status` filter: real statuses plus UPCOMING / PAST. */
export const ENTERPRISE_APPOINTMENT_FILTER = {
  ...ENTERPRISE_APPOINTMENT_STATUS,
  UPCOMING: 'UPCOMING',
  PAST: 'PAST',
} as const;

export const UPCOMING_APPOINTMENT_STATUSES = new Set<EnterpriseAppointmentStatus>([
  ENTERPRISE_APPOINTMENT_STATUS.PENDING,
  ENTERPRISE_APPOINTMENT_STATUS.SCHEDULED,
  ENTERPRISE_APPOINTMENT_STATUS.CONFIRMED,
]);

export const PAST_APPOINTMENT_STATUSES = new Set<EnterpriseAppointmentStatus>([
  ENTERPRISE_APPOINTMENT_STATUS.DONE,
  ENTERPRISE_APPOINTMENT_STATUS.COMPLETED,
]);
